const restApi = process.env.REACT_APP_REST_API

export default async function rest(resource: string, method = 'GET', body: any = undefined) {
  const opts: { method?: string, headers?: any, body?: any } = {
    method,
    headers: {},
  }
  const token = localStorage.getItem('token')
  if (token) {
    opts.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`
  }
  if (['POST', 'PUT'].includes(method)) {
    opts.headers['Content-Type'] = 'application/json'
    opts.body = JSON.stringify(body)
  }

  try {
    const res = await fetch(`${restApi}/api/${resource}`, opts)

    try {
      const json = await res.json()

      if (!res.ok) {
        // Trata erro na resposta do json
        if (json.code === 'token_not_valid') {
          localStorage.removeItem('token')
          window.location.reload()
          return null
        }
        throw json
      }
      return json
    } catch (error) {
      if (error instanceof Error) {
        // Trata erro na leitura do json
        throw new Error('Erro ' + res.status + ' (' + res.statusText + ') no recurso: /api/' + resource.split('?')[0])
      } else {
        throw error
      }
    }
  } catch (error) {
    if (error.message) {
      const newError = ({ detail: error.message })
      throw newError
    } else {
      throw error
    }
  }
}
